import {Region} from "src/app/constant/Enums";

const DEV_REGIONS: Map<Region, string> = new Map();
DEV_REGIONS.set(Region.NA, 'http://ee-portal.dev-na.com');
DEV_REGIONS.set(Region.EU, 'http://ee-portal.dev-eu.com');
DEV_REGIONS.set(Region.FE, 'http://ee-portal.dev-fe.com');


const BETA_REGIONS: Map<Region, string> = new Map();
BETA_REGIONS.set(Region.NA, 'https://ee-portal.beta-na.flex-altitude-irm.last-mile.amazon.dev');
BETA_REGIONS.set(Region.EU, 'https://ee-portal.beta-eu.flex-altitude-irm.last-mile.amazon.dev');
BETA_REGIONS.set(Region.FE, 'https://ee-portal.beta-fe.flex-altitude-irm.last-mile.amazon.dev');

const GAMMA_REGIONS: Map<Region, string> = new Map();
GAMMA_REGIONS.set(Region.NA, 'https://ee-portal.gamma-na.flex-altitude-irm.last-mile.amazon.dev');
GAMMA_REGIONS.set(Region.EU, 'https://ee-portal.gamma-eu.flex-altitude-irm.last-mile.amazon.dev');
GAMMA_REGIONS.set(Region.FE,'https://ee-portal.gamma-fe.flex-altitude-irm.last-mile.amazon.dev');

const PROD_REGIONS: Map<string, string> = new Map();
PROD_REGIONS.set(Region.NA, 'https://ee-portal.prod-na.flex-altitude-irm.last-mile.amazon.dev');
PROD_REGIONS.set(Region.EU, 'https://ee-portal.prod-eu.flex-altitude-irm.last-mile.amazon.dev');
PROD_REGIONS.set(Region.FE, 'https://ee-portal.prod-fe.flex-altitude-irm.last-mile.amazon.dev');

export {DEV_REGIONS, BETA_REGIONS, GAMMA_REGIONS, PROD_REGIONS}